import {Component, Inject, OnInit, Output, EventEmitter} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";



interface DataDialog{
  value: boolean,
  text: string
}

@Component({
  selector: 'app-push-notification-dialog',
  templateUrl: './push-notification-dialog.component.html',
  styleUrls: ['./push-notification-dialog.component.scss']
})
export class PushNotificationDialogComponent implements OnInit {


  constructor(
    public dialogRef: MatDialogRef<PushNotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataDialog
  ) { }

  ngOnInit(): void {
  }

  onNoClick() {
    return  this.data.value = false
  }

  onYes(){
   return  this.data.value = true
  }

}
